import {convertServerDateToLocalMoment} from '../utility/date/date-converter';

export default {
  methods: {
    dateLarge(date, timezone) {
      return convertServerDateToLocalMoment(date, undefined, timezone).format('LLL'); //August 9 2017 9:32 PM
    },
    dateMedium(date, timezone) {
      return convertServerDateToLocalMoment(date, undefined, timezone).format('lll'); //Aug 9 2017 9:32 PM
    },
    dateSmall(date, timezone) {
      return convertServerDateToLocalMoment(date, undefined, timezone).format('L'); //i.e. 06/09/2017
    },
  },
};
